import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoldActivityService {


  url = environment.serverAPI4 + "/api/goldlone";

  url1 = environment.serverAPI4 + "/api";

  constructor(private http: HttpClient) { }

  searchGoldActivityReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/due${queryParams}`, requestBody);
  }

  getGoldLoanDueTotal(query: any) {

     const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url1}/due/total`, requestBody);
  }

  GoldActivityUpcomingReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/upcoming${queryParams}`, requestBody);
  }

    getGoldLoanUpcomingTotal(query: any) {

     const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url1}/upcoming/total`, requestBody);
  }


}
